const ENRoom = {
	"Adicionar sala": "Add room",
	"Alterar sala": "Change room",
	"Criar nova sala": "Create new room",
	"Deseja realmente excluir a sala": "Do you really want to delete the room",
	"Erro ao adicionar sala": "Error on adding room",
	"Erro ao alterar sala": "Error on changing room",
	"Erro ao excluir sala": "Error on deleting room",
	"Exclusão da sala": "Delete room",
	"Descrição da sala é requerida": "Room's description is required",
	"Nova sala": "New room",
	"Sala adicionada com sucesso": "Room successfully added",
	"Sala alterada com sucesso": "Room successfully changed",
	"Sala excluída com sucesso": "Room successfully deleted",
	"Salas de reunião": "Meeting rooms"
};

export default ENRoom;
